import {
    GESTION_OPERATIVA_UPDATE_FINANCING_DATA_SUCCESS,
    GESTION_OPERATIVA_UPDATE_FINANCING_DATA_FAILURE,
    GESTION_OPERATIVA_UPDATE_FINANCING_DATA_BEGIN
  } from './constants'
  import { BFFAgent } from '../../../common/BFFAgent'
  import { financing } from '@asofix/core'
  /**
   * Actualiza los datos de financiamiento.
   *
   * @param {Object} params - Parametros para actualizar los datos de financiamiento.
   * @param {string} params.credit_line_id - Identificador de la linea de credito.
   * @param {number} params.tna - Tasa Nominal Anual (TNA).
   * @param {number} params.montoFinanciar - Monto a financiar.
   * @param {number} params.quantity - Cantidad de cuotas.
   * @param {number} params.quebrantoPorc - Porcentaje de quebranto.
   * @param {number} params.expenses - Gastos.
   * @param {number} params.creditLineCost - Costo de la linea de credito.
   * @param {number} params.avgQuoteValue - Valor promedio de la cotizacion.
   * @param {number} params.firstFeeValue - Valor de la primera cuota.
   * @param {boolean} params.calculateAvgQuote - Indica si se debe calcular el valor promedio de la cotizacion.
 */
  export function updateFinancingData({
        credit_line_id,
        tna,
        montoFinanciar,
        quantity,
        quebrantoPorc,
        expenses,
        creditLineCost,
        avgQuoteValue,
        firstFeeValue,
        calculateAvgQuote
    }) {
    return dispatch => {
      dispatch({
        type: GESTION_OPERATIVA_UPDATE_FINANCING_DATA_BEGIN,
      })
      const promise = new Promise((resolve, reject) => {
        const doRequest = BFFAgent.Sales.updateFinancingData(
            credit_line_id,
            tna,
            montoFinanciar,
            quantity,
            avgQuoteValue,
            firstFeeValue,
            calculateAvgQuote,
            expenses,
            quebrantoPorc
        )
        doRequest.then(
          res => {
            let credit_line_dcosts = creditLineCost
            if(montoFinanciar && (quebrantoPorc || expenses)) {
              credit_line_dcosts = (montoFinanciar * quebrantoPorc) / 100 + expenses
            }

            let initial_fee_updated = financing.getInitialFee(montoFinanciar, firstFeeValue)

            dispatch({
                type: GESTION_OPERATIVA_UPDATE_FINANCING_DATA_SUCCESS,
                data: {
                    ...res,
                    tna,
                    credit_line_dcosts,
                    montoFinanciar,
                    firstFeeValue: initial_fee_updated
                }
            })
            resolve(res)
          },
          // Use rejectHandler as the second argument so that render errors won't be caught.
          err => {
            dispatch({
              type: GESTION_OPERATIVA_UPDATE_FINANCING_DATA_FAILURE,
              data: { error: err }
            })
            reject(err)
          }
        )
      })
      return promise
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case GESTION_OPERATIVA_UPDATE_FINANCING_DATA_BEGIN:
        return {
          ...state,
          sale: { 
            ...state.sale,
            updateFinancingDataPending: true,
          },
        }

        case GESTION_OPERATIVA_UPDATE_FINANCING_DATA_SUCCESS:
          
        // The request is success
        return {
          ...state,
          sale: {
            ...state.sale,
            credit_line_cft: action.data.cft,
            monthly_avg_fee: action.data.coutaProm,
            credit_line_tna: action.data.tna,
            credit_line_dcosts: action.data.credit_line_dcosts,
            amount_2b_financed: action.data.montoFinanciar,
            credit_line_first_quote_value: action.data.firstFeeValue,
            updateFinancingDataPending: false,
          }
        }
  
      case GESTION_OPERATIVA_UPDATE_FINANCING_DATA_FAILURE:
        // The request is failed
        return {
          ...state,
          sale: { ...state.sale, updateFinancingDataPending: false},
        }
  
      default:
        return state
    }
  }
  